/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { HasId, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ALIGN, defaultTimelineDots, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import { HTML as _HTML } from "../../contentType"
import DataDummy from "../../landing-edit/DataDummy"
import { IDataComponentsProps } from "../DataComponents"
import { setHorizontalAlignToCSSRule } from "../Section" 
import TimelineDiagram from "../../contentType/cards/timeline/TimelineDiagram"
import { CSSObjectToString, getID } from "src/libs/utilities"
import VerticalTimelineTitle from "./VerticalTimelineTitle"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { DataContentAnimateContainer } from "./DataContentAnimateContainer"
import { DataContentPositionContainer } from "./DataContentPositionContainer"

/* Protopia Ecosystem component */
export interface ISectionVerticalTimelineProps extends IDataComponentsProps {
   
}
const SectionVerticalTimeline = (props: ISectionVerticalTimelineProps): JSX.Element => {
    const [section, setSection] = useState<ILandingSection>(props.section)  
    const sizes                 = useLandingSize()
    const composition           = useComposition( section )
    const is_two_side           = sizes.width >= WINDOW_WIDTH.TABLET && composition.columns > 1
    const [timelineId]          = useState<string>(getID("section"))
    
    useEffect(() => {
        addCSSClass(
            `section-vertical-timeline-container-${props.section.id}`,
            `.section-vertical-timeline-container-${props.section.id} {
                ${setHorizontalAlignToCSSRule(props.section.vertical_align || ALIGN.MIDDLE )};
                .landing-vertical-timeline-title-container {
                    ${ CSSObjectToString( props.section.dots?.title_style || {} ) }
                }
            }
            .landing-v-timeline-container {
                align-items: flex-start;
            }

            .landing-v-timeline-cards-${props.section.id}-left,
            .landing-v-timeline-cards-${props.section.id} { 
                z-index:1; 
            }
                
            .landing-v-timeline-cards-${props.section.id}-left {
                margin-right : 0!important;
                align-items: flex-end!important;
            }`
        ) 
        return () => { 
            removeCSSClass( `section-vertical-timeline-container-${props.section.id}` )
        }
    }, [section])
    
    useEffect(() => { 
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => { 
                const sec: ILandingSection = currentLanding.sections.find(s => s.id === props.section.id)!                            
                if( JSON.stringify( sec ) !== JSON.stringify( section ) ) { 
                    setSection(() => {
                        return sec
                    })
                }
            }, 
            {} 
        ) 
        return () => {
            unsubscribe(); 
        }
    }, [])

    if(!props.section) {
        return <></>
    }
    return <div 
        className={ `landing-data-components-container landing-edit-cont ${section.className || ""} section-vertical-timeline-container-${props.section.id}` }  
        style={{...section.dstyle, gap: section.gap }} 
        data-proportia={composition.proportia.join(",")} 
    >
        <div className={`landing-v-timeline-container `} data-vertical-timeline-id={timelineId}>
            {
                is_two_side && <div className={`landing-v-timeline-cards landing-v-timeline-cards-${props.section.id}-left `} >
                    {
                        "LEFT"
                    }
                </div>
            }
            <TimelineDiagram 
                {...props} 
                timelineId={timelineId}
                data={{
                    cards: props.data as HasId[],
                    is_two_side,
                    dots: props.section.dots || defaultTimelineDots()
                }} 
            />
            <div className={`landing-v-timeline-cards landing-v-timeline-cards-${props.section.id}  `} >
            <div className="timeline-shifter" />
                {
                    props.data.filter((card, i) => { 
                        return i % 2 === 1 || !is_two_side
                    })
                    .map((data, i) => { 
                        if(data.isHidden) {
                            return <DataDummy key={ data.id } data={data} section={props.section} />
                        }
                        const type = data.type
                        const DataComponent = type && components()[ type ]
                            ?
                            components()[ type ].c
                            :
                            _HTML 
                        return <div className="landing-vertical-timeline-item" key={ data.id } style={{ marginBottom: 25 }}> 
                            <DataContentAnimateContainer 
                                {...props}
                                i={ i }  
                                proportia={ !!composition.proportia ? composition.proportia[i] : 100 / composition.columns }
                                className={`landing-card-${ data.id }`} 
                            >
                                <>
                                    <VerticalTimelineTitle card={ data } />
                                    <DataContentPositionContainer {...props} i={i} >
                                        <DataComponent  
                                            section={ section } 
                                            data={ { ...data, type } } 
                                        /> 
                                    </DataContentPositionContainer>
                                </>
                            </DataContentAnimateContainer>
                        </div>
                    }) 
                }
            </div> 
        </div>
    </div>
}
export default SectionVerticalTimeline